import { hasTokenExpired } from '../../auth'
import { INACTIVITY_EVENTS, INACTIVITY_PERIOD } from '../../constants'

export default {
  data () {
    return {
      inactiveTimer: null
    }
  },
  created () {
    this.setInactiveEvents()
  },
  beforeDestroy () {
    this.clearInactiveEvents()
  },
  methods: {
    setInactiveEvents () {
      INACTIVITY_EVENTS.forEach(event => window.addEventListener(event, this.setTimer))
      this.setTimer() // handles the case where the user refreshes the page
    },
    setTimer () {
      if (this.inactiveTimer) clearTimeout(this.inactiveTimer)

      this.inactiveTimer = setTimeout(() => {
        if (this.$store.getters.isLogged && !hasTokenExpired(this.$store.state.token)) {
          this.logout()
        }
      }, INACTIVITY_PERIOD)
    },
    logout () {
      this.$store.dispatch('logout')
      if (this.$route.name !== 'Login') this.$router.push({ name: 'Login' })
    },
    clearInactiveEvents () {
      INACTIVITY_EVENTS.forEach(event => window.removeEventListener(event, this.setTimer))
      if (this.inactiveTimer) clearTimeout(this.inactiveTimer)
    }
  }
}
